import React, {useState} from 'react';
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import {Field, FieldArray, Form, Formik} from "formik";
import AutoSaveWithDebounce from "../common/Autosave/AutoSaveWithDebounce";
import Preloader from "../common/Preloader/Preloader";
import Collapse from "@material-ui/core/Collapse";
import Button from "@material-ui/core/Button";
import {themeButtons} from "../../css/themeButtons";
import {FormControlCheckBoxes, GreenCheckbox} from "./styles";
import FormControl from "@material-ui/core/FormControl";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {useHistory} from "react-router-dom";
import AlertSavePage from "../common/AlertSavePage/AlertSavePage";


const RenderCheckInCkeckOut = ({preSavePage, checkIn, checkOut, selectedCheckIn, selectedCheckOut}) => {

    const preSaveForm = (values) => {
        preSavePage({checkIn: values.checkIn, checkOut: values.checkOut})
    }


    return (
        <div id="timing" className="section">
            <h5 className="card-title mb-3">
                Расчетные часы:
            </h5>

            <Formik
                initialValues={{
                    checkIn: selectedCheckIn ? selectedCheckIn : '',
                    checkOut: selectedCheckOut ? selectedCheckOut : ''
                }}
                onSubmit={preSaveForm}
                enableReinitialize>
                {({values}) => (
                    <Form>
                        <div className="row g-2">
                            <div className="col-md-6"><Field name="checkIn">
                                {({field, form}) => (
                                    <FormControl
                                        fullWidth
                                        variant="outlined"
                                        size="small">
                                        <InputLabel id="demo-simple-select-outlined-label">
                                            Время заезда</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            label="Время заезда"
                                            {...field}
                                        >
                                            {checkIn && checkIn.values.map(item => (
                                                <MenuItem key={item.value} value={item.value}>
                                                    {item.label}
                                                </MenuItem>)
                                            )}

                                        </Select>


                                    </FormControl>
                                )}
                            </Field></div>
                            <div className="col-md-6">
                                <Field name="checkOut">
                                    {({field, form}) => (
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            size="small">
                                            <InputLabel>Время выезда</InputLabel>
                                            <Select
                                                label="Время выезда"
                                                {...field}
                                            >
                                                {checkOut && checkOut.values.map(item => (
                                                    <MenuItem key={item.value} value={item.value}>
                                                        {item.label}
                                                    </MenuItem>)
                                                )}

                                            </Select>


                                        </FormControl>
                                    )}
                                </Field>
                            </div>
                        </div>


                        <AutoSaveWithDebounce debounceMs={10}/>

                    </Form>
                )}
            </Formik>

        </div>
    )
}

const RenderRules = ({ruleName, rules, preSavePage}) => {

    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const preSaveForm = (values) => {
        let filtredTrueCheckbox = values.values.filter(item => item.selected === true)

        let saveArr = []
        filtredTrueCheckbox.map((item) => {
            saveArr.push(item.value)
        })


        preSavePage({[ruleName]: saveArr})
    }

    const buttons = themeButtons();
    return (
        <Formik initialValues={rules}
                onSubmit={preSaveForm}
                enableReinitialize>
            {({handleSubmit, values}) => (
                <Form onSubmit={handleSubmit} className="section">
                    <FieldArray name={ruleName}>
                        {({}) => (
                            <div id={ruleName}>
                                <h5 className="card-title mb-2">
                                    {rules.label}
                                </h5>
                                <div className="row g-3">
                                    {rules.values.slice(0, 8).map((rule, index) =>
                                        <div key={index} className="col-12 col-md-6 col-lg-4 col-xxl-3">
                                            <Field type="checkbox" name={`values.${index}.selected`}>
                                                {({field}) => (
                                                    <FormControlCheckBoxes
                                                        label={rule.label}
                                                        control={<GreenCheckbox {...field}/>}
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    )}

                                </div>

                                {rules.values.length > 7
                                && <>
                                    <Collapse className="mt-3" in={expanded} timeout="auto" unmountOnExit>
                                        <div className="row g-3">
                                            {rules.values && rules.values.slice(8).map((rule, index) =>
                                                <div key={index} className="col-12 col-md-6 col-lg-4 col-xxl-3">
                                                    <Field type="checkbox" name={`values.${index + 8}.selected`}>
                                                        {({field}) => (
                                                            <FormControlCheckBoxes
                                                                label={rule.label}
                                                                control={<GreenCheckbox {...field}/>}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                            )}
                                        </div>
                                    </Collapse>
                                    <div className="col-12 mt-3">
                                        {expanded
                                            ? <Button
                                                className={`btn ${buttons.btnLight}`}
                                                onClick={handleExpandClick}>
                                                Скрыть
                                                <FontAwesomeIcon icon={"chevron-up"} className="ms-1"/>

                                            </Button>
                                            : <Button
                                                className={`btn ${buttons.btnLight}`}
                                                onClick={handleExpandClick}>
                                                Показать все
                                                <FontAwesomeIcon icon={"chevron-down"} className="ms-1"/>
                                            </Button>
                                        }
                                    </div>
                                </>
                                }

                            </div>
                        )}
                    </FieldArray>

                    <AutoSaveWithDebounce debounceMs={10}/>
                </Form>

            )}
        </Formik>
    )
}


const ObjectRules = (props) => {
    const [preSavedPage, setPreSavedPage] = useState({})
    const [unsavedPage, toggleUnsavedPage] = useState(false)
    const {rules, checkIn, checkOut, objectId, savePage, selectedCheckIn, selectedCheckOut} = props
    const [targetRedirectLink, setTargetRedirectLink] = useState(false)
    const history = useHistory()

    const preSavePage = (values) => {
        setPreSavedPage({...preSavedPage, ...values})
        toggleUnsavedPage(true)
    }


    //сохранение страницы
    const savePageHandler = async () => {
        toggleUnsavedPage(false)
        let response = await savePage({object: objectId, section: "rules", data: preSavedPage})
        if (response) {
            if (targetRedirectLink) {
                history.push(targetRedirectLink)
            }
        }
    }

    if (!rules) {
        return <Preloader loading={true}/>
    }
    return (
        <div className="main edit-object">

            <div className="container-fluid">
                <RenderCheckInCkeckOut preSavePage={preSavePage} checkIn={checkIn} checkOut={checkOut}
                                       selectedCheckIn={selectedCheckIn} selectedCheckOut={selectedCheckOut}/>

                {Object.keys(rules).map(rule =>
                    <RenderRules key={rule} ruleName={rule} rules={rules[rule]} preSavePage={preSavePage}/>
                )}
            </div>

            {unsavedPage && <StickyBottomButton action={savePageHandler}/>}
            <AlertSavePage unsavedPage={unsavedPage} btnOkAction={savePageHandler}
                           setTargetRedirectLink={setTargetRedirectLink} targetRedirectLink={targetRedirectLink}/>

            <FunctionSidebarContainer/>
        </div>
    )
}


export default ObjectRules;